import { ComponentProps } from "react";
import { create } from "zustand";

import GenericModal from "./GenericModal";
import { ModalId, Params, ParamsInput } from "./types";

export const useModal = create<{
  isOpen: boolean;
  modalId: ModalId | null;
  params: Params<ModalId> | null;
  display: <T extends ModalId>(modalId: T, params?: ParamsInput<T>) => void;
  close: () => void;
}>()((set) => ({
  isOpen: false,
  modalId: null,
  params: null,
  display: (modalId, params) => {
    set({ isOpen: true, params, modalId });
  },
  close: () => set({ isOpen: false, modalId: null, params: null }),
}));

export const useDisplayGenericModal = () => {
  const { display } = useModal();
  return (props: ComponentProps<typeof GenericModal>) => display("GENERIC_MODAL", props);
};
